export default {
  telegramCampaignCode: '',
  username: '',
  telegramId: '',
  telegramParams: {},
  telegramToRouterPath: '',
  tgBindingStatus: 1, // tgBindingStatus 0 绑定 1 未绑定
  tgBtn: true,
  resBind: false,
  tgLinks: {},
  vtMarketsBot: {
    bot_id: '',
    telegram_login: '',
  },
  tgOriPath: '',
  skipResetTgLink: false,

  // bottom tab related
  sidebarMenu: {},
  sidebarMenuActive: '',
}
